import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;

const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

/**
 * Format of options :
 * [{id: 1, title: 'Option 1'}, {id: 2, title: 'Option 2'}, ...]
 */
export default function MultiSelect({options, value, onChange, label}){


    const handleChange = event => {
        const val = event.target.value;

        const ids = typeof val === 'string' ? val.split(',') : val;

        const items = ids.map(id => options.find(o => o.id === id));

        return onChange(items);
    }


    const renderValue = selected => selected
        .map(s => options.find(o => o.id === s)?.title)
        .join(', ')


    const idsValue = Array.isArray(value) ? value.map(i => i.id) : [];


    return <FormControl size='small'>

        <InputLabel>{label}</InputLabel>

        <Select
            multiple
            value={idsValue}
            onChange={handleChange}
            input={<OutlinedInput label={label} />}
            renderValue={renderValue}
            MenuProps={MenuProps}
            size='small'
        >
            {options.map(o => (
                <MenuItem key={o.id} value={o.id}>
                    <Checkbox checked={idsValue.includes(o.id)} />
                    <ListItemText primary={o.title} />
                </MenuItem>
            ))}
        </Select>

    </FormControl>
}